﻿/**
 * Art (Kind) von Einträgen in der Personen-Änderungshistorie.
 * Werte wie vom Backend in GET /api/v1/persons/:id/change-history zurückgegeben.
 * Für Vergleiche verwenden statt Magic Strings.
 */
export const PERSON_CHANGE_KIND_PERSON_DATA_CHANGE = "PersonDataChange";
export const PERSON_CHANGE_KIND_PERSON_DATA_CHANGE_EVENT = "PersonDataChangeEvent";
export const PERSON_CHANGE_KIND_PERSON_DATA_UNDO = "PersonDataUndo";
export const PERSON_CHANGE_KIND_REST_PERIOD_CREATED = "RestPeriodCreated";
export const PERSON_CHANGE_KIND_REST_PERIOD_UPDATED = "RestPeriodUpdated";
export const PERSON_CHANGE_KIND_REST_PERIOD_UNDO = "RestPeriodUndo";
export const PERSON_CHANGE_KIND_REST_PERIOD_DELETED = "RestPeriodDeleted";
export const PERSON_CHANGE_KIND_CONTRACT_PACKAGE_CANCELLATION_REVOKED = "ContractPackageCancellationRevoked";
export const PERSON_CHANGE_KIND_PAYMENT_CREATED = "PaymentCreated";
export const PERSON_CHANGE_KIND_PAYMENT_UPDATED = "PaymentUpdated";
export const PERSON_CHANGE_KIND_PAYMENT_CANCELLED = "PaymentCancelled";
export const PERSON_CHANGE_KIND_REMINDER_LEVEL_RESET = "ReminderLevelReset";
export const PERSON_CHANGE_KIND_REMINDER_RETRY_CREATED = "ReminderRetryCreated";
export const PERSON_CHANGE_KIND_REMINDER_RETRY_NOTIFICATION_CONFIRMED = "ReminderRetryNotificationConfirmed";
export const PERSON_CHANGE_KIND_REMINDER_BLOCKED = "ReminderBlocked";
export const PERSON_CHANGE_KIND_REMINDER_BLOCK_RELEASED = "ReminderBlockReleased";
export const PERSON_CHANGE_KIND_APP_CONSENT = "AppConsent";
export const PERSON_CHANGE_KIND_MEMBER_APP_REQUEST = "MemberAppRequest";
export const PERSON_CHANGE_KIND_CONTRACT_PACKAGE_CREATED = "ContractPackageCreated";
export const PERSON_CHANGE_KIND_CONTRACT_PACKAGE_CANCELLED = "ContractPackageCancelled";
export const PERSON_CHANGE_KIND_WALLET_CREATED = "WalletCreated";
export const PERSON_CHANGE_KIND_ARTICLE_SALE_CREATED = "ArticleSaleCreated";
export const PERSON_CHANGE_KIND_ARTICLE_SALE_CANCELLED = "ArticleSaleCancelled";
export const PERSON_CHANGE_KIND_ARTICLE_SALE_DELETED = "ArticleSaleDeleted";
export const PERSON_CHANGE_KIND_ARTICLE_SALE_SEPA_GROUP_CHANGED = "ArticleSaleSepaGroupChanged";
export const PERSON_CHANGE_KIND_CHARGEBACK_FOLLOW_UP_COMPLETED = "ChargebackFollowUpCompleted";
